// import { PropType } from "vue";
// import { DateTimeProps } from "./type";

export default {
  modelValue: String,
  defaultValue: [String, Number],
};
